import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import authenService from "../services/authenService";
import constants from "../constants";
import h from "../services/h";
import vbNotificationService from "../services/vbNotificationService";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  // strict: debug,
  state: {
    user: null,
    userDeptRoles: null,
    userDeptRoleId: null,
    notificationsUnreadCount: 0,
    notifies: [],
    pageable: {
      page: 0,
      size: 10,
      sort: "createTime,desc"
    },
    calendarStatusFilter: null,
    enableMenuCodes: [],
    serverTime: null,
  },
  mutations: {
    setCalendarStatusFilter(state, data) {
      state.calendarStatusFilter = data;
    },

    setNameRoute(state, payload) {
      state.nameRoute = payload;
    },

    loadMore(state, data) {
      state.notifies = state.notifies.concat(data);
    },

    login(state, loginData) {
      state.user = loginData.user;
      state.userDeptRoles = loginData.userDeptRoles;
    },

    changeAvatar(state, data) {
      state.user = { ...state.user, iconPhoto: data.iconPhoto, avatar: data.avatar }
    },

    changeProfile(state, data) {
      state.user = { ...state.user, ...data };
    },

    changeUserDeptRole(state, userDeptRoleId) {
      state.userDeptRoleId = userDeptRoleId;
      authenService.store(
        constants.STORAGE_KEY.USER_DEPT_ROLE_ID,
        state.userDeptRoleId
      );
      vbNotificationService.findAll(state.pageable).then(response => {
        state.notifies = response.data;
      });
      vbNotificationService.countUnSeen()
        .then(response => {
          state.notificationsUnreadCount = response.data;
        })

      //load thong tin notify;
    },

    subCount(state) {
      state.notificationsUnreadCount -= 1;
    },

    startLoading(state) {
      state.isLoadingFlag++;
    },

    stopLoading(state) {
      state.isLoadingFlag--;
    },

    setFullScreen(state) {
      state.fullScreen = true;
    },
    setHalfScreen(state) {
      state.fullScreen = false;
    },
    setEnableMenuCodes(state, data) {
      state.enableMenuCodes = data;
    },
    setServerTime(state, time) {
      state.serverTime = time;
    },
  },
  actions: {},
  getters: {
    userDeptRoles: state => state.userDeptRoles,
    user: state => state.user,
    notificationsUnreadCount: state => state.notificationsUnreadCount,
    userDeptRoleId: state => state.userDeptRoleId,
    userDeptRole: state => {
      return h.find(
        state.userDeptRoles,
        userDeptRole => userDeptRole.id === state.userDeptRoleId
      );
    },
    notifies: state => state.notifies,
    calendarStatusFilter: state => state.calendarStatusFilter,
    enableMenuCodes: state => state.enableMenuCodes,
  },
  plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/store/index.js